export default {
    state: {
        appointment: '',
        location: {},
        calendar_settings_data: null,
        date: {},
        company: '',
        calendar_settings_account: null,
        calendar_reserved_slots: [],
        events: [],
        appointment_exists_period: {
            start: new Date(),
            end: new Date(),
        },
        appointment_reserved_slots_exists: [],
    },
    mutations: {
        PLAN_APPOINTMENT(state, data) {
            state.appointment = data;
        },
        PLAN_LOCATION(state, data) {
            state.location = data;
        },
        PLAN_DATE(state, data) {
            state.date = data;
        },
        PLAN_COMPANY(state, data) {
            state.company = data;
        },
        CALENDAR_SETTINGS_DATA(state, data) {
            state.calendar_settings_data = data;
        },
        CALENDAR_SETTINGS_ACCOUNT(state, data) {
            state.calendar_settings_account = data;
        },
        CALENDAR_RESERVED_SLOTS(state, data) {
            state.calendar_reserved_slots.push(...data);
        },
        CALENDAR_RESERVED_SLOTS_EXISTS(state, data) {
            state.appointment_reserved_slots_exists.push(data);
        },
        CALENDAR_COMMIT_EVENTS(state, newEvents) {
            state.events = newEvents;
        },
        CALENDAR_COMMIT_EVENTS_CONCAT(state, newEvents) {
            const eventForConcat = newEvents.filter((item) => !(state.events.find((stateItem) => stateItem.id === item.id)));
            state.events.push(...eventForConcat);
        },
        CALENDAR_APPOINTMENT_EXISTS_PERIOD(state, appointment_exists_period) {
            state.appointment_exists_period = {
                start: new Date(Math.min(+state.appointment_exists_period.start, +appointment_exists_period.start)),
                end: new Date(Math.max(+state.appointment_exists_period.end, +appointment_exists_period.end)),
            };
        },
        CALENDAR_APPOINTMENT_EXISTS_PERIOD_CLEAR(state) {
            state.appointment_exists_period = {
                start: new Date(),
                end: new Date(),
            };
        },
        CALENDAR_DATE_CLEAR(state) {
            state.appointment_exists_period = {
                start: new Date(),
                end: new Date(),
            };
            state.events = [];
            state.calendar_reserved_slots = [];
            state.appointment_reserved_slots_exists = [];
        },
    },
    actions: {
        storePlanAppointment({ commit, state }, payload) {
            commit('PLAN_APPOINTMENT', payload);
        },
        storePlanLocation({ commit, state }, payload) {
            commit('PLAN_LOCATION', payload);
        },
        storePlanDate({ commit, state }, payload) {
            commit('PLAN_DATE', payload);
        },
        storeCalendarSettingsData({ commit, state }, payload) {
            commit('CALENDAR_SETTINGS_DATA', payload);
        },
        storeCalendarViewSettingsAccount({ commit, state }, payload) {
            commit('CALENDAR_SETTINGS_ACCOUNT', payload);
        },
        storeCalendarReservedSlots({ commit, state }, payload) {
            commit('CALENDAR_RESERVED_SLOTS', payload);
        },
    },
};
